import moment from "moment-timezone";

import { useGetRisksRiskDirectoryIdInsightsSuspense } from "api/generated/risks/risks";

export function useInsightsSuspenseQuery(
    id: number,
    entityId: number | undefined,
    start: moment.Moment,
    end: moment.Moment
) {
    return useGetRisksRiskDirectoryIdInsightsSuspense(
        id,
        {
            start: start.toISOString(true),
            end: end.toISOString(true),
            entity_id: entityId,
        },
        { query: { select: (response) => response.data } }
    );
}
